import {UserDto} from "./user.dto";
import {LegalDocumentDto} from "./legal-document.dto";
import {AgreementDto} from "./agreement.dto";
import {NoticeDto, NoticeRemindDto} from "./notice.dto";
import {ValidationErrorDto} from "./validation-error.dto";
import {EmailDto} from "./email.dto";
import {KeyValueDto} from "./key-value.dto";
import {VoidDto} from "./void.dto";
import {AuthLogoutDto} from "./auth-logout.dto";
import {ExceptionErrorDto} from "./exception-error.dto";
import {NumberConfigDto} from "./number-config.dto";
import {OrgDto} from "./org.dto";
import {SettingDto} from "./setting.dto";
import {SearchContactRes} from "./search/search-contact.res";
import {ContactDto} from "./contact.dto";
import {AddressDto} from "./address.dto";
import {VatRateDto} from "./vat-rate.dto";
import {CurrencyDto} from "./currency.dto";
import {ArticleDto} from "./article.dto";
import {CatalogDto} from "./catalog.dto";
import {GoodsGroupDto} from "./goods-group.dto";
import {SearchArticleRes} from "./search/search-article.res";
import {PhoneDto} from "./phone.dto";
import {BankAddressDto} from "./bank-address.dto";
import {SearchInvoiceRes} from "./search/search-invoice.res";
import {InvoiceDto} from "./document/invoice.dto";
import {InvoicePositionDto} from "./document/invoice-position.dto";
import {InvoiceArticleDto} from "./document/invoice-article.dto";
import {MediaDto} from "./media.dto";
import {VehicleDto} from "./vehicle/vehicle.dto";
import {VehicleEngineDto} from "./vehicle/vehicle-engine.dto";
import {VehicleTypeDto} from "./vehicle/vehicle-type.dto";
import {VehicleManufacturerDto} from "./vehicle/vehicle-manufacturer.dto";
import {VehicleModelDto} from "./vehicle/vehicle-model.dto";
import {VehicleVariantDto} from "./vehicle/vehicle-variant.dto";
import {OverviewDto} from "./overview-dto";
import {CredentialsDto} from "./credentials.dto";
import {SearchReceiptRes} from "./search/search-receipt.res";
import {ReceiptDto} from "./receipt.dto";
import {SearchBookingCategoryRes} from "./search/search-booking-category.res";
import {ReceiptPositionDto} from "./receipt-position.dto";
import {OrgUserDto} from "./org-user.dto";
import {OrgGroupDto} from "./org-group.dto";
import {SearchOrgUserRes} from "./search/search-org-user.res";
import {SearchOrgGroupRes} from "./search/search-org-group.res";
import {CheckDto} from "./check.dto";
import {DeliveryNoteDto} from "./delivery-note.dto";
import {DocumentExchangeDto} from "./document-exchange.dto";
import {NotificationDto} from "./notification.dto";
import {FeatureDto} from "./feature.dto";
import {InfoDto} from "./info.dto";
import {DocumentPaymentEntryDto} from "./document-payment-entry.dto";
import {isDefined} from "../../libs/utils/epic.utils";
import {SearchVehicleRes} from "./vehicle/search-vehicle.res";
import {OccurrenceDto} from "./occurrence.dto";
import {TextTemplateDto} from "./text-template.dto";
import {SearchTextTemplateRes} from "./search/search-text-template.res";
import {EditLockDto} from "./edit-lock.dto";
import {SearchCatalogRes} from "./search/search-catalog.res";
import {OrgWalletDto} from "./org-wallet.dto";
import {SearchOrgWalletTransactionRes} from "./search/search-org-wallet-transaction.res";
import {PaypalLinkDto} from "./paypal-link.dto";
import {OrgWalletTransactionDto} from "./org-wallet-transaction.dto";
import {PaymentProviderCallbackDto} from "./payment-provider-callback.dto";
import {OrgFeatureQuotaDto} from "./org-feature-quota.dto";
import {LetterPriceDto} from "./letter-price.dto";
import {DocumentContactDto} from "./document-contact.dto";
import {SearchCorrespondenceRes} from "./search/search-correspondence.res";
import {CorrespondenceDto} from "./correspondence.dto";
import {SearchVehicleHistoryRes} from "./vehicle/search-vehicle-history.res";
import {VehicleHistoryDto} from "./vehicle/vehicle-history.dto";
import {VehicleRepairDto} from "./vehicle/vehicle-repair.dto";
import {SearchVehicleRepairRes} from "./vehicle/search-vehicle-repair.res";
import {HyperlinkDto} from "./hyperlink.dto";
import {StatisticTopInvoiceArticleDto} from "./statistic/statistic-top-invoice-article.dto";
import {StatisticProfitLossDto} from "./statistic/statistic-profit-loss.dto";
import {StatisticTopInvoiceContactDto} from "./statistic/statistic-top-invoice-contact.dto";
import {StatisticTopInvoiceVehicleDto} from "./statistic/statistic-top-invoice-vehicle.dto";
import {StatisticTopContactVehicleDto} from "./statistic/statistic-top-contact-vehicle.dto";
import {StatisticTopReceiptContactDto} from "./statistic/statistic-top-receipt-contact.dto";
import {DocumentCommentDto} from "./document-comment.dto";
import {SearchCommentRes} from "./search/search-comment.res";
import {ProformaInvoiceDto} from "./proforma-invoice.dto";
import {CatalogImportStatusDto} from "./catalog-import-status.dto";
import {VehicleTireDto} from "./vehicle/vehicle-tire.dto";
import {SearchVehicleTireRes} from "./vehicle/search-vehicle-tire.res";
import {ExportStatusDto} from "./export-status.dto";
import {SendLetterDto} from "./send-letter.dto";
import {ReceiptDiscountDto} from "./receipt-discount.dto";
import {StatisticReceiptTypeCategoryDto} from "./statistic/statistic-receipt-type-category.dto";
import {SupportTicketDto} from "./support-ticket.dto";
import {SupportStatusDto} from "./support-status.dto";
import {SearchSupportTicketRes} from "./search/search-support-ticket.res";
import {SearchMediaRes} from "./search/search-media.res";
import {SearchRegistryOfficeRes} from "./search/search-registry-office.res";
import {RegistryOfficeDto} from "./registry-office.dto";
import {SearchDeathRes} from "./search/search-death.res";
import {DeathDto} from "./death.dto";
import {ContactRelationDto} from "./contact.relation.dto";
import {SearchContactRelationRes} from "./search/search-contact-relation.res";
import {SearchGoodsGroupRes} from "./search/search-goods-group.res";
import {DocumentPropertyDto} from "./document-property.dto";
import {InvoiceExchangePositionDto} from "./document/invoice-exchange-position.dto";
import {PaypalOrderDto} from "./paypal-order.dto";
import {OrderDto} from "./order.dto";
import {AffiliateDto} from "./affiliate.dto";
import {AffiliateReferredDto} from "./affiliate-referred.dto";
import {SheetDto} from "./document/sheet.dto";
import {SearchSheetRes} from "./search/search-sheet.res";
import {BounceDto} from "./bounce.dto";

export class WrapperDto<T> {

  public ts!: Date; // Timestamp
  public datas: T[] = [];
  public dataType!: string;
  public errors: T[] = [];
  public status!: number;
  public code!: string;
  public cnf: string[] = []; // Client-Notifications

  constructor(init?: Partial<WrapperDto<T>>) {
    Object.assign(this, init);
    if (isDefined(init?.datas)) {
      this.datas = init.datas.map((i) => this.initObject(i));
    } else {
      this.datas = [];
    }
    if (isDefined(init?.errors)) {
      this.errors = init.errors.map((i) => this.initObject(i));
    } else {
      this.errors = [];
    }
  }

  public getFirstData(): T {
    return this.datas[0];
  }

  public getDatas(): T[] {
    return this.datas;
  }

  public getFirstError(): T {
    return this.errors[0];
  }

  public getErrors(): T[] {
    return this.errors;
  }

  private initObject(data: any): any {
    switch (this.dataType) {
      case 'UserDto':
        return new UserDto(data);
      case 'LegalDocumentDto':
        return new LegalDocumentDto(data);
      case 'AgreementDto':
        return new AgreementDto(data);
      case 'BounceDto':
        return new BounceDto(data);
      case 'NoticeDto':
        return new NoticeDto(data);
      case 'NoticeRemindDto':
        return new NoticeRemindDto(data);
      case 'OrgDto':
        return new OrgDto(data);
      case 'EmailDto':
        return new EmailDto(data);
      case 'SettingDto':
        return new SettingDto(data);
      case 'KeyValueDto':
        return new KeyValueDto(data);
      case 'NumberConfigDto':
        return new NumberConfigDto(data);
      case 'ContactDto':
        return new ContactDto(data);
      case 'AddressDto':
        return new AddressDto(data);
      case 'PhoneDto':
        return new PhoneDto(data);
      case 'VatRateDto':
        return new VatRateDto(data);
      case 'CurrencyDto':
        return new CurrencyDto(data);
      case 'ArticleDto':
        return new ArticleDto(data);
      case 'CatalogDto':
        return new CatalogDto(data);
      case 'CatalogImportStatusDto':
        return new CatalogImportStatusDto(data);
      case 'GoodsGroupDto':
        return new GoodsGroupDto(data);
      case 'BankAddressDto':
        return new BankAddressDto(data);
      case 'InvoiceDto':
        return new InvoiceDto(data);
      case 'InvoicePositionDto':
        return new InvoicePositionDto(data);
      case 'InvoiceExchangePositionDto':
        return new InvoiceExchangePositionDto(data);
      case 'InvoiceArticleDto':
        return new InvoiceArticleDto(data);
      case 'DocumentExchangeDto':
        return new DocumentExchangeDto(data);
      case 'DocumentContactDto':
        return new DocumentContactDto(data);
      case 'MediaDto':
        return new MediaDto(data);
      case 'DeliveryNoteDto':
        return new DeliveryNoteDto(data);
      case 'ProformaInvoiceDto':
        return new ProformaInvoiceDto(data);
      case 'VehicleDto':
        return new VehicleDto(data);
      case 'VehicleHistoryDto':
        return new VehicleHistoryDto(data);
      case 'VehicleRepairDto':
        return new VehicleRepairDto(data);
      case 'VehicleTireDto':
        return new VehicleTireDto(data);
      case 'VehicleEngineDto':
        return new VehicleEngineDto(data);
      case 'VehicleTypeDto':
        return new VehicleTypeDto(data);
      case 'VehicleManufacturerDto':
        return new VehicleManufacturerDto(data);
      case 'VehicleModelDto':
        return new VehicleModelDto(data);
      case 'VehicleVariantDto':
        return new VehicleVariantDto(data);
      case 'OverviewDto':
        return new OverviewDto(data);
      case 'CredentialsDto':
        return new CredentialsDto(data);
      case 'ReceiptDto':
        return new ReceiptDto(data);
      case 'ReceiptPositionDto':
        return new ReceiptPositionDto(data);
      case 'OrgUserDto':
        return new OrgUserDto(data);
      case 'OrgGroupDto':
        return new OrgGroupDto(data);
      case 'AuthLogoutDto':
        return new AuthLogoutDto(data);
      case 'VoidDto':
        return new VoidDto(data);
      case 'CheckDto':
        return new CheckDto(data);
      case 'NotificationDto':
        return new NotificationDto(data);
      case 'FeatureDto':
        return new FeatureDto(data);
      case 'OrgFeatureQuotaDto':
        return new OrgFeatureQuotaDto(data);
      case 'OrgWalletDto':
        return new OrgWalletDto(data);
      case 'OrgWalletTransactionDto':
        return new OrgWalletTransactionDto(data);
      case 'InfoDto':
        return new InfoDto(data);
      case 'DocumentPaymentEntryDto':
        return new DocumentPaymentEntryDto(data);
      case 'OccurrenceDto':
        return new OccurrenceDto(data);
      case 'HyperlinkDto':
        return new HyperlinkDto(data);
      case 'TextTemplateDto':
        return new TextTemplateDto(data);
      case 'EditLockDto':
        return new EditLockDto(data);
      case 'StatisticProfitLossDto':
        return new StatisticProfitLossDto(data);
      case 'ValidationErrorDto':
        return new ValidationErrorDto(data);
      case 'ExceptionErrorDto':
        return new ExceptionErrorDto(data);
      case 'PaypalLinkDto':
        return new PaypalLinkDto(data);
      case 'PaypalOrderDto':
        return new PaypalOrderDto(data);
      case 'PaymentProviderCallbackDto':
        return new PaymentProviderCallbackDto(data);
      case 'LetterPriceDto':
        return new LetterPriceDto(data);
      case 'CorrespondenceDto':
        return new CorrespondenceDto(data);
      case 'StatisticTopInvoiceArticleDto':
        return new StatisticTopInvoiceArticleDto(data);
      case 'StatisticTopInvoiceContactDto':
        return new StatisticTopInvoiceContactDto(data);
      case 'StatisticTopInvoiceVehicleDto':
        return new StatisticTopInvoiceVehicleDto(data);
      case 'StatisticTopContactVehicleDto':
        return new StatisticTopContactVehicleDto(data);
      case 'StatisticTopReceiptContactDto':
        return new StatisticTopReceiptContactDto(data);
      case 'StatisticReceiptTypeCategoryDto':
        return new StatisticReceiptTypeCategoryDto(data);
      case 'DocumentCommentDto':
        return new DocumentCommentDto(data);
      case 'ExportStatusDto':
        return new ExportStatusDto(data);
      case 'SendLetterDto':
        return new SendLetterDto(data);
      case 'ReceiptDiscountDto':
        return new ReceiptDiscountDto(data);
      case 'SupportTicketDto':
        return new SupportTicketDto(data);
      case 'SupportStatusDto':
        return new SupportStatusDto(data);
      case 'RegistryOfficeDto':
        return new RegistryOfficeDto(data);
      case 'DeathDto':
        return new DeathDto(data);
      case 'ContactRelationDto':
        return new ContactRelationDto(data);
      case 'DocumentPropertyDto':
        return new DocumentPropertyDto(data);
      case 'OrderDto':
        return new OrderDto(data);
      case 'AffiliateDto':
        return new AffiliateDto(data);
      case 'AffiliateReferredDto':
        return new AffiliateReferredDto(data);
      case 'SheetDto':
        return new SheetDto(data);
      /*
       * Search
       */
      case 'SearchContactRes':
        return new SearchContactRes(data);
      case 'SearchArticleRes':
        return new SearchArticleRes(data);
      case 'SearchInvoiceRes':
        return new SearchInvoiceRes(data);
      case 'SearchReceiptRes':
        return new SearchReceiptRes(data);
      case 'SearchBookingCategoryRes':
        return new SearchBookingCategoryRes(data);
      case 'SearchOrgUserRes':
        return new SearchOrgUserRes(data);
      case 'SearchOrgGroupRes':
        return new SearchOrgGroupRes(data);
      case 'SearchVehicleRes':
        return new SearchVehicleRes(data);
      case 'SearchVehicleHistoryRes':
        return new SearchVehicleHistoryRes(data);
      case 'SearchVehicleRepairRes':
        return new SearchVehicleRepairRes(data);
      case 'SearchVehicleTireRes':
        return new SearchVehicleTireRes(data);
      case 'SearchTextTemplateRes':
        return new SearchTextTemplateRes(data);
      case 'SearchOrgWalletTransactionRes':
        return new SearchOrgWalletTransactionRes(data);
      case 'SearchCatalogRes':
        return new SearchCatalogRes(data);
      case 'SearchCorrespondenceRes':
        return new SearchCorrespondenceRes(data);
      case 'SearchCommentRes':
        return new SearchCommentRes(data);
      case 'SearchSupportTicketRes':
        return new SearchSupportTicketRes(data);
      case 'SearchMediaRes':
        return new SearchMediaRes(data);
      case 'SearchRegistryOfficeRes':
        return new SearchRegistryOfficeRes(data);
      case 'SearchDeathRes':
        return new SearchDeathRes(data);
      case 'SearchContactRelationRes':
        return new SearchContactRelationRes(data);
      case 'SearchGoodsGroupRes':
        return new SearchGoodsGroupRes(data);
      case 'SearchSheetRes':
        return new SearchSheetRes(data);
      case 'SearchResultDto':
        throw new Error('Type-related search not implemented in wrapper');
      default:
        throw new Error('Datatype "' + this.dataType + '" not implemented in wrapper');
    }
  }
}
